export const HELP_TOOL_TIP = {
  TOOLTIP: 'helpTooltip',
  CLOSE_BUTTON: 'helpTooltipCloseButton',
  CONTENT: 'helpTooltipContent',
  TEXT_CONTENT: 'helpTooltipTextContent',
  TITLE: 'helpTooltipTitle',
  DESCRIPTION: 'helpTooltipDescription'
} as const;
